
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcabs() {



  const cardData =
  {
    keyword: 'Pune Airport Cabs',
    heading: 'AB Ghule Cabs: Pune Airport Cabs',
    headingDescription: 'AB Ghule Cabs provides reliable, comfortable, and affordable cab services to Pune Airport. Whether you are catching a flight, arriving at the airport, or need a hassle-free ride to your destination, our fleet of well-maintained vehicles and professional drivers ensure a smooth and timely journey. With our affordable rates and excellent customer service, we aim to make your travel experience easy and stress-free.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Pune Airport Cabs',

    topPlaces: [
        {
          title: "Timely Service",
          description: "Our drivers are trained to ensure you reach the airport or your destination on time. We track your flight or arrival time to avoid delays and ensure punctual service."
        },
        {
          title: "Comfortable Ride",
          description: "Choose from a variety of well-maintained vehicles like sedans, SUVs, and luxury cars for a smooth, comfortable, and relaxed ride to or from Pune Airport."
        },
        {
          title: "Affordable Prices",
          description: "We offer competitive prices with no hidden charges. Whether you need a one-way trip or a round trip, our pricing is transparent and budget-friendly."
        },
        {
          title: "Experienced Drivers",
          description: "Our professional drivers are knowledgeable about the best routes to avoid traffic and ensure a quick, safe journey. They are also trained to assist with your luggage, ensuring a pleasant experience."
        },
        {
          title: "24/7 Availability",
          description: "Whether you have an early morning or late-night flight, AB Ghule Cabs operates around the clock, providing airport cab services 24/7 for your convenience."
        },
        {
          title: "Easy Online Booking",
          description: "Booking a cab with AB Ghule Cabs is simple and hassle-free. You can book your cab online or via phone in advance, ensuring your travel plans are secured."
        },
        {
          title: "Clean and Safe Vehicles",
          description: "All our vehicles are regularly cleaned and sanitized to provide you with a safe and hygienic travel experience, especially during these times."
        },
        {
          title: "Reliable Airport Pickup and Drop",
          description: "We offer both pickup and drop services from Pune Airport to your desired location. Our drivers are well-versed in the airport layout and ensure a smooth pickup and drop-off process."
        },
        {
          title: "No Surge Pricing",
          description: "Unlike some ride-sharing services, we do not have surge pricing. The price you see at the time of booking is what you pay, with no surprises."
        },
        {
          title: "VIP Services",
          description: "For those looking for an extra touch of luxury, we offer premium services with luxury vehicles for a more comfortable and elegant airport transfer experience."
        }
      ],


      
      services: [
        {
          "name": "Pune Airport Taxi Services",
          description: "AB Ghule Cabs provides excellent taxi services at Pune Airport. Whether you’re arriving or departing, our fleet of well-maintained vehicles ensures a comfortable ride. Book your taxi service easily through our online portal for a hassle-free experience."
        },
        {
          "name": "Pune to Mumbai Airport Taxi",
          description: "Need a taxi from Pune to Mumbai Airport? AB Ghule Cabs offers affordable and comfortable taxi services with expert drivers who know the fastest routes. Book a one-way or round-trip taxi for a convenient airport drop-off."
        },
        {
          "name": "Pune to Mumbai Airport Drop",
          description: "If you’re traveling from Pune to Mumbai Airport, AB Ghule Cabs ensures you a safe and timely drop-off. Our drivers are professional, punctual, and equipped with knowledge of the best routes for a smooth and comfortable journey."
        },
        {
          "name": "Pune Airport Taxi Booking",
          description: "Booking a taxi at Pune Airport has never been easier. With AB Ghule Cabs, you can quickly book your taxi online for airport pick-up or drop-off. We provide a wide variety of vehicles to cater to your travel needs, from sedans to luxury cars."
        },
        {
          "name": "Pune to Shirdi Cab Service",
          description: "If you’re looking to visit Shirdi, AB Ghule Cabs offers an affordable and reliable taxi service. Whether you need a one-way or round-trip service, our fleet of cars, including luxury taxis, ensures you travel in comfort and safety."
        },
        {
          "name": "Pune Airport to Shirdi Taxi Service",
          description: "Looking for a taxi from Pune Airport to Shirdi? AB Ghule Cabs provides prompt and reliable airport-to-Shirdi taxi services. Our drivers are experienced and familiar with the best routes, ensuring a quick and comfortable trip to your destination."
        },
        {
          "name": "Pune to Shirdi Cab Booking",
          description: "Easily book your Pune to Shirdi cab with AB Ghule Cabs for a smooth journey. Our taxi services are available 24/7 with affordable rates and a range of vehicles including SUVs and sedans."
        },
        {
          "name": "Mumbai Airport to Pune Taxi Booking",
          description: "Traveling from Mumbai to Pune? AB Ghule Cabs offers a premium and budget-friendly taxi service for your convenience. You can book a one-way taxi for a seamless and comfortable ride between the two cities."
        },
        {
          "name": "Pune to Mumbai Airport One-Way Taxi",
          description: "AB Ghule Cabs provides affordable one-way taxi services from Pune to Mumbai Airport. Our experienced drivers ensure that you reach the airport on time, making your travel hassle-free."
        },
        {
          "name": "Book Pune Airport Taxi",
          description: "You can easily book your Pune airport taxi through AB Ghule Cabs online platform. Whether you need a ride from the airport or to the airport, we ensure timely pick-ups with a wide selection of vehicles available for you to choose from."
        },
        {
          "name": "Affordable Pune to Shirdi Taxi",
          description: "For affordable and reliable taxi services from Pune to Shirdi, AB Ghule Cabs is your best choice. We offer competitive pricing with excellent customer service, ensuring a smooth and comfortable ride for your spiritual journey."
        },
        {
          "name": "Pune Airport to Mumbai One-Way Taxi",
          description: "AB Ghule Cabs offers one-way taxi services from Pune Airport to Mumbai, giving you an economical and stress-free ride. Book your cab for a swift, hassle-free journey, and reach your destination comfortably."
        },
        {
          "name": "Pune to Mumbai Taxi",
          description: "Traveling from Pune to Mumbai? AB Ghule Cabs offers the most reliable taxi service. Whether you need a one-way or round-trip taxi, our drivers are well-versed in the best routes, ensuring timely and comfortable travel."
        },
        {
          "name": "Pune Airport Taxi Services Online Booking",
          description: "Booking your taxi service online for Pune Airport is simple with AB Ghule Cabs. Choose from a variety of vehicles that suit your needs, and book your ride in just a few steps. Enjoy a comfortable airport transfer at the best price."
        },
        {
          "name": "Mumbai to Pune Airport Taxi Service",
          description: "For a smooth transfer from Mumbai to Pune Airport, AB Ghule Cabs offers a dependable taxi service. Our fleet of cars and professional drivers will make your journey stress-free and enjoyable."
        },
        {
          "name": "Pune to Shirdi Taxi Charges",
          description: "AB Ghule Cabs offers competitive rates for taxi services from Pune to Shirdi. Whether you're traveling in a sedan, SUV, or tempo traveller, our pricing is transparent, and there are no hidden charges."
        },
        {
          "name": "Pune to Mumbai Airport Taxi Fare",
          description: "The taxi fare from Pune to Mumbai Airport is affordable and competitive with AB Ghule Cabs. Our fare includes all charges like taxes, tolls, and fuel costs, ensuring you get a fair price for your trip."
        },
        {
          "name": "Airport Taxi Pune to Shirdi",
          description: "Choose AB Ghule Cabs for your airport taxi needs from Pune to Shirdi. Our experienced drivers will take you directly to Shirdi in a comfortable, well-maintained vehicle at a reasonable fare."
        },
        {
          "name": "Cheapest Pune to Mumbai Airport Taxi",
          description: "AB Ghule Cabs offers the most affordable taxi services from Pune to Mumbai Airport. We provide the best rates without compromising on quality and comfort. Enjoy an economical ride with us today!"
        },
        {
          "name": "Book Cab for Pune Airport Drop",
          description: "Planning to drop someone off at Pune Airport? Book a reliable cab from AB Ghule Cabs. Our professional drivers will ensure a comfortable ride for you and your loved ones, and you'll reach the airport on time."
        },
        {
          "name": "Pune to Shirdi Car Hire",
          description: "If you need a private car for your journey from Pune to Shirdi, AB Ghule Cabs offers excellent car hire services. Enjoy your spiritual journey with a comfortable ride in one of our well-maintained vehicles."
        },
        {
          "name": "Pune to Shirdi Taxi Cost",
          description: "AB Ghule Cabs offers affordable taxi services for your Pune to Shirdi journey. Our fare includes all taxes, tolls, and additional charges, ensuring that you get a budget-friendly yet comfortable ride."
        },
        {
          "name": "Book a Cab for Pune Airport",
          description: "Booking a cab for Pune Airport is easy and quick with AB Ghule Cabs. Whether you need a pick-up or a drop-off, our service guarantees timely arrivals and departures with a range of vehicles to choose from."
        },
        {
          "name": "Pune Airport to Shirdi One-Way Taxi",
          description: "Traveling from Pune Airport to Shirdi? Book a one-way taxi with AB Ghule Cabs and enjoy a comfortable and timely journey. Our professional drivers are always on time to pick you up and ensure a pleasant ride."
        },
        {
          "name": "Pune Airport Cab Rental",
          description: "AB Ghule Cabs offers convenient car rentals for trips to and from Pune Airport. Whether you need a one-way trip or a round-trip, we offer a range of vehicles that are clean, comfortable, and ready to take you wherever you need to go."
        },
        {
          "name": "Pune Airport Cabs Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune Airport Cabs. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],


        tableData: [
            ["Pune airport cabs", "-Mumbai airport to Pune cab"],
            ["Pune Airport Cab Services", "-Pune Airport Taxi Booking"],
            ["Pune Airport Car Rental", "-Pune Airport Taxi Rate"],
            ["Pune Airport Cab Charges", "-Pune Airport Taxi Booking Online"],
            ["Pune Airport Cab Pricing", "-Pune Airport Car Hire with Driver"],
            ["pune airport cabs", "-Pune to Shirdi cab one way"],
            ["Pune to Mumbai airport cab fare", "-Pune to Mumbai Airport"],
            ["Pune Mumbai airport drop", "-Pune airport to Shirdi cab"],
            ["One way cab Mumbai to Pune", "-Pune Mumbai cab service"],
            ["Pune to Mumbai Taxi Service", "-Pune airport to Shirdi taxi"],
            ["Airport taxi Pune", "-Pune Airport Taxi"],
            ["Outstation Car rental Pune", "-Airport Drop Pune"],
            ["Pune airport to Shirdi cab price", "-Airport cab service Pune"],
            ["Airport pickup and drop Pune", "-Airport taxi service in Pune"],
            ["Book Airport Cab Pune", "-Book cab for Pune airport"],
            ["Cheapest Ashtavinayak tour from Pune", ""]
          ],
          
          whychoose: [
            {
              WhyChooseheading: "Reliable and Punctual Service",
              WhyChoosedescription: "At AB Ghule Cabs, we ensure that your ride to or from Pune Airport is smooth and timely. Our drivers are punctual and committed to getting you to your destination on time, so you never have to worry about missing your flight or getting delayed."
            },
            {
              WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
              WhyChoosedescription: "Whether you're traveling for business or leisure, our fleet of air-conditioned and well-maintained vehicles will ensure a comfortable ride. We offer a range of vehicles, from sedans to SUVs, so you can choose the one that best suits your preferences."
            },
            {
              WhyChooseheading: "Experienced and Professional Drivers",
              WhyChoosedescription: "Our drivers are experienced, professional, and fully trained to provide a safe and smooth journey. They are familiar with the best routes to and from the airport, ensuring minimal delays and a stress-free ride."
            },
            {
              WhyChooseheading: "Affordable and Transparent Pricing",
              WhyChoosedescription: "AB Ghule Cabs offers affordable airport cab services with no hidden fees. We provide clear, upfront pricing, so you know exactly what you’ll pay before your journey begins."
            },
            {
              WhyChooseheading: "24/7 Availability",
              WhyChoosedescription: "Whether your flight arrives early in the morning or late at night, AB Ghule Cabs is available 24/7. Our services are designed to cater to your needs at any time of the day or night, making sure you never miss a ride to or from the airport."
            },
            {
              WhyChooseheading: "Easy and Convenient Booking",
              WhyChoosedescription: "Booking a cab with AB Ghule Cabs is quick and simple. You can book a ride through our website, mobile app, or by contacting our customer service team. We also offer immediate booking for last-minute requests."
            },
            {
              WhyChooseheading: "Customer Satisfaction Guaranteed",
              WhyChoosedescription: "We are dedicated to providing excellent customer service. Our commitment to customer satisfaction is evident through our positive reviews and repeat customers. We strive to ensure that your experience is smooth, safe, and hassle-free."
            }
          ]
          
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab to or from Pune Airport?',
      answer: 'You can easily book a cab through our website, mobile app, or by calling our customer service team. We provide a seamless booking process for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'How much time in advance should I book my Pune Airport cab?',
      answer: 'We recommend booking your cab at least 1-2 hours before your flight departure for airport drop-offs and 30-45 minutes before your arrival for pick-ups. However, we can accommodate last-minute bookings as well.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers experienced with airport routes?',
      answer: 'Yes, all our drivers are well-trained and familiar with the fastest and most efficient routes to and from Pune Airport, ensuring that you reach your destination on time.',
    },
    {
      id: 'FAQ4',
      question: 'What types of vehicles are available for airport transfers?',
      answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars, to accommodate different travel needs and preferences.',
    },
    {
      id: 'FAQ5',
      question: 'Do you offer 24/7 cab service for Pune Airport?',
      answer: 'Yes, we operate 24/7, so you can rely on us for your early morning or late-night airport transfers. Whether you\'re arriving or departing at any hour, we\'ll be there for you.',
    },
    {
      id: 'FAQ6',
      question: 'How do I pay for my Pune Airport cab ride?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments through our website or app, making it easy and convenient for you to pay for your ride.',
    },
    {
      id: 'FAQ7',
      question: 'Are there any additional charges for waiting at the airport?',
      answer: 'There may be an additional waiting charge if the driver has to wait for an extended period beyond the agreed pick-up time. However, this will be communicated to you beforehand, and we ensure transparency in pricing.',
    },
    {
      id: 'FAQ8',
      question: 'Do you provide airport pick-up services?',
      answer: 'Yes, we offer airport pick-up services from Pune Airport. Our driver will be waiting for you at the arrival terminal with a name board, ensuring you are easily spotted and picked up promptly.',
    },
    {
      id: 'FAQ9',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. If you need assistance, our customer service team is available to help.',
    },
    {
      id: 'FAQ10',
      question: 'Is AB Ghule Cabs available for long-distance trips after airport pick-up?',
      answer: 'Yes, we offer long-distance travel services after airport pick-up. If you need to travel from the airport to other destinations like Mumbai, Lonavala, or any nearby city, we can accommodate that request as well.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rahul Joshi',
      feedback: 'I used AB Ghule Cabs for my airport transfer, and I was extremely impressed with their service. The driver was punctual, the car was clean and comfortable, and the entire experience was seamless. I highly recommend their services for anyone needing a reliable ride to or from Pune Airport!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Shah',
      feedback: 'AB Ghule Cabs is my go-to service for airport transfers. Their drivers are professional, and the booking process is always smooth. I never have to worry about being late for my flights. Fantastic service!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div><Helmet>
    <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune Airport Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
    <meta name="description" content="Book your Pune Airport Cabs with AB Ghule Cabs. Offering reliable, affordable taxi services and car rentals for Pune Airport pickup and drop, one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
    <meta name="keywords" content="Pune airport cabs, Mumbai airport to Pune cab, Pune Airport Cab Services, Pune Airport Taxi Booking, Pune Airport Car Rental, Pune Airport Taxi Rate, Pune Airport Cab Charges, Pune Airport Taxi Booking Online, Pune Airport Cab Pricing, Pune Airport Car Hire with Driver, Pune to Shirdi cab one way, Pune to Mumbai airport cab fare, Pune to Mumbai Airport, Pune Mumbai airport drop, Pune airport to shirdi cab, One way cab Mumbai to Pune, Pune Mumbai cab service, Pune to Mumbai Taxi Service, Pune airport to shirdi taxi, Airport taxi Pune, Pune Airport Taxi, Outstation Car rental Pune, Airport Drop Pune, Pune airport to shirdi cab price" />
    <meta name="robots" content="index, follow" />
    <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune Airport Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
    <meta property="og:description" content="Book your Pune Airport Cabs with AB Ghule Cabs. Offering reliable, affordable taxi services and car rentals for Pune Airport pickup and drop, one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
    <meta property="og:image" content="https://abghulecabs.com/images/pune-airport-cabs.jpg" />
    <meta property="og:url" content="https://abghulecabs.com/pune-airport-cabs" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="AB Ghule Cabs" />
  
    {/* JSON-LD Structured Data for Schema Markup */}
    <script type="application/ld+json">
      {`
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "AB Ghule Cabs - Pune Airport Cabs",
          description: "Book your Pune Airport Cabs with AB Ghule Cabs. Offering reliable, affordable taxi services and car rentals for Pune Airport pickup and drop, one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Pune, Maharashtra",
            "addressLocality": "Pune",
            "addressRegion": "Maharashtra",
            "postalCode": "411001",
            "addressCountry": "IN"
          },
          "telephone": "+91-8624029699",
          "url": "https://abghulecabs.com/pune-airport-cabs",
          "logo": "https://abghulecabs.com/images/pune-airport-cabs.jpg",
          "image": "https://abghulecabs.com/images/pune-airport-cabs.jpg",
          "priceRange": "₹1500 - ₹5000",
          "offers": {
            "@type": "Offer",
            "url": "https://abghulecabs.com/pune-airport-cabs",
            "priceCurrency": "INR",
            "price": "1500",
            "priceValidUntil": "2024-12-31"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "125"
          },
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Kiran M"
              },
              "datePublished": "2024-11-12",
              "reviewBody": "Excellent service from Pune Airport! The cab was punctual, and the driver was very friendly. Will definitely use AB Ghule Cabs again."
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Rohit S"
              },
              "datePublished": "2024-09-28",
              "reviewBody": "The booking process was smooth, and the taxi was comfortable. Highly recommend their airport taxi service!"
            }
          ],
          "serviceArea": {
            "@type": "Place",
            "name": "Pune Airport Cabs",
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "18.5204",
              "longitude": "73.8567"
            }
          },
          "availableChannel": {
            "@type": "ServiceChannel",
            "serviceUrl": "https://abghulecabs.com/pune-airport-cabs"
          },
          "keywords": "Pune airport cabs, Mumbai airport to Pune cab, Pune Airport Cab Services, Pune Airport Taxi Booking, Pune Airport Car Rental, Pune Airport Taxi Rate, Pune Airport Cab Charges, Pune Airport Taxi Booking Online, Pune Airport Cab Pricing, Pune Airport Car Hire with Driver, Pune to Shirdi cab one way, Pune to Mumbai airport cab fare, Pune to Mumbai Airport, Pune Mumbai airport drop, Pune airport to shirdi cab, One way cab Mumbai to Pune, Pune Mumbai cab service, Pune to Mumbai Taxi Service, Pune airport to shirdi taxi, Airport taxi Pune, Pune Airport Taxi, Outstation Car rental Pune, Airport Drop Pune, Pune airport to shirdi cab price"
        }
      `}
    </script>
  </Helmet>
  
      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/32.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Puneairportcabs;